/* eslint-disable react/display-name */
/**
 *
 * FormularioPreguntas
 *
 */

import { memo } from 'react';

import { lazyLoad } from 'utils/loadable';

import { OperationsRouting } from './operations.routing';
interface Props {}

export const OperationsComponent = memo((props: Props) => {
  return (
    <>
      <div></div>
      <OperationsRouting />
    </>
  );
});

export const OperationsModule = lazyLoad(
  () => import('./operations.module'),
  (module) => module.OperationsComponent
);
